import React from 'react';
import './Datenschutz.css';

export default function Datenschutz() {
  return (
    <main className="datenschutz-container">
      <h1>Datenschutzerklärung</h1>

      <h2>1. Verantwortlicher</h2>
      <p>
        Schwimm und Tauchgemeinschaft DiverDuck e.V.<br />
        Seestraße 12<br />
        12345 Tauchstadt<br />
        E-Mail: info@diverduck.de
      </p>

      <h2>2. Erhebung und Speicherung personenbezogener Daten</h2>
      <p>
        Beim Besuch unserer Website werden durch den Browser automatisch Informationen an unseren Server übermittelt und in sogenannten Server-Logfiles gespeichert.
        Dazu gehören:
      </p>
      <ul>
        <li>IP-Adresse</li>
        <li>Datum und Uhrzeit des Zugriffs</li>
        <li>Verwendeter Browser und Betriebssystem</li>
        <li>Verweisende URL (Referrer)</li>
      </ul>

      <h2>3. Kontaktformular</h2>
      <p>
        Wenn Sie das Kontaktformular nutzen, erheben wir die von Ihnen eingegebenen Daten (z. B. Name, E-Mail-Adresse, Nachricht).
        Diese Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage genutzt und nicht an Dritte weitergegeben.
        Die Übertragung erfolgt unverschlüsselt per E-Mail.
      </p>

      <h2>4. Verlinkte PDF-Dateien</h2>
      <p>
        Auf unserer Website können PDF-Dateien (z. B. für Anmeldeformulare) verlinkt sein. Beim Öffnen dieser Dateien findet ggf. ein Zugriff auf externe Server statt (z. B. beim PDF-Hosting).
        Wir übernehmen keine Verantwortung für die Inhalte externer Seiten.
      </p>

      <h2>5. Speicherdauer</h2>
      <p>
        Personenbezogene Daten aus Anfragen werden nur so lange gespeichert, wie dies für die Bearbeitung notwendig ist. Danach werden sie gelöscht.
      </p>

      <h2>6. Ihre Rechte</h2>
      <p>Sie haben das Recht:</p>
      <ul>
        <li>Auskunft über Ihre gespeicherten Daten zu erhalten</li>
        <li>Unrichtige Daten berichtigen zu lassen</li>
        <li>Daten löschen oder deren Verarbeitung einschränken zu lassen</li>
        <li>Widerspruch gegen die Datenverarbeitung einzulegen</li>
        <li>Beschwerde bei der zuständigen Aufsichtsbehörde einzulegen</li>
      </ul>

      <h2>7. Kontakt</h2>
      <p>
        Für Fragen zum Datenschutz wenden Sie sich bitte an:<br />
        info@diverduck.de
      </p>
    </main>
  );
}
